/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

Fancybox.bind('[data-fancybox]', {
    // Custom options
}); 
// closing of top bar
document.addEventListener("DOMContentLoaded", function() {
// Get the close button
var closeButton = document.querySelector('.top-bar-close');
// Get the top-bar element
var topBar = document.querySelector('.top-bar');

// Add click event listener to the close button
closeButton.addEventListener('click', function() {
    // Hide the top-bar element
    topBar.style.display = 'none';
});
});

/*for header color change on scroll*/
document.addEventListener("DOMContentLoaded", function() {
window.addEventListener("scroll", function() {
    var header = document.getElementById("header");
    if (window.pageYOffset > 0) {
        header.classList.add("active");
        header.style.backgroundColor = "#fff";
    } else {
        header.classList.remove("active");
        header.style.backgroundColor = "transparent";
    }
});
});


/*nav bar*/
jQuery(document).ready(function () {
jQuery(".hamburger button").click(function () {
    jQuery(this).toggleClass("active");
    jQuery(".left-side").toggleClass("nav-active");
    if (jQuery(".left-side").hasClass("nav-active")) {
        jQuery("body").css("overflow", "hidden");
    } else {
        jQuery("body").css("overflow", "");
    }
});

// mobile dropdown start//
// jQuery(".mobile-click").click(function() {
//     if (jQuery(window).width() < 991) {
//         // Check if the clicked tab is already active
//         var isActive = jQuery(this).hasClass('active');

//         // Remove active class from all tabs
//         jQuery(".mobile-click").removeClass('active');
//         // Close all other tabs
//         jQuery(".mobile-click").not(this).parent().find('ul').slideUp();
    
//         // Toggle the clicked tab and add active class if it wasn't active
//         jQuery(this).parent().find('ul').slideToggle();
//         if (!isActive) {
//             jQuery(this).addClass('active');
//         }
//     }
// });
jQuery(".mobile-click").click(function(event) {
if (jQuery(window).width() < 991) {
    // Check if the clicked element is .mblMenuLink
    if (jQuery(event.target).hasClass('mblMenuLink')) {
        return; // Do nothing if .mblMenuLink is clicked
    }

    // Check if the clicked tab is already active
    var isActive = jQuery(this).hasClass('active');

    // Remove active class from all tabs
    jQuery(".mobile-click").removeClass('active');
    // Close all other tabs
    jQuery(".mobile-click").not(this).parent().find('ul').slideUp();
    
    // Toggle the clicked tab and add active class if it wasn't active
    jQuery(this).parent().find('ul').slideToggle();
    if (!isActive) {
        jQuery(this).addClass('active');
    }
}
});


// mobile dropdown end //
});




/*slick slider*/
jQuery('.slider-section').slick({
dots: false,
infinite: true,
arrows:true,
slidesToShow: 5,
autoplaySpeed: 5000,
slidesToScroll: 1,
loop: true,
autoplay: false,
margin: 32,
responsive: [
    {
        breakpoint: 1367,
        settings: {
          slidesToShow: 4,
        },
      },
    {
      breakpoint: 1281,
      settings: {
        slidesToShow: 3,
      },
    },
    {
    breakpoint: 992,
    settings: {
      slidesToShow: 2,
    },
  },
  {
    breakpoint: 767,
    settings: {
      slidesToShow: 1,
    },
  },
  ],
});

//filter tabbing
document.addEventListener("DOMContentLoaded", function() {
var tabs = document.querySelectorAll('.content-tabs ul li');

tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
        var tab_id = this.getAttribute('data-tab');
        document.querySelectorAll('.content-tabs ul li').forEach(function(tab) {
            tab.classList.remove('current');
        });
        document.querySelectorAll('.tab-content').forEach(function(content) {
            content.classList.remove('current');
        });
        this.classList.add('current');
        document.getElementById(tab_id).classList.add('current');
    });
});
});

//filter screen
document.addEventListener("DOMContentLoaded", function() {
var filterBtn = document.querySelector('.filter-btn');
var filterScreen = document.getElementById('filter-screen');
var overlay = document.querySelector('.overlay');
var body = document.querySelector('body');
var closeIcon = filterScreen.querySelector('.icon-close');

filterBtn.addEventListener('click', function() {
    filterScreen.classList.add('show-filter');
    overlay.classList.add('active');
    body.classList.add('no-scroll');
});

closeIcon.addEventListener('click', function() {
    filterScreen.classList.remove('show-filter');
    overlay.classList.remove('active');
    body.classList.remove('no-scroll');
});
});



//load more button function
jQuery(function () {
jQuery(".col-md-4").slice(0, 20).show();
jQuery("body").on('click touchstart', '.load-more', function (e) {
    e.preventDefault();
    jQuery(".col-md-4:hidden").slice(0, 5).slideDown();
    if (jQuery(".col-md-4:hidden").length == 0) {
        jQuery(".load-more").css('visibility', 'hidden');
    }
    jQuery('html,body').animate({
        scrollTop: jQuery(this).offset().top
    }, 1000);
});

});
jQuery(function () {
// Show only the first .terms-content section initially
jQuery(".terms-content").slice(1).hide(); // Hide all but the first .terms-content

// Handle click or touchstart event on the "Load More" button
jQuery("body").on('click touchstart', '.readMoreTerms', function (e) {
    e.preventDefault();

    // Find the next hidden .terms-content section after the currently visible one
    var nextSection = jQuery(".terms-content:hidden:first");

    // If there is a next hidden section, reveal it with slideDown animation
    if (nextSection.length > 0) {
        nextSection.slideDown();

        // Scroll to the clicked "Load More" button for a smooth user experience
        jQuery('html,body').animate({
            scrollTop: jQuery(this).offset().top
        }, 1000);

        // If there are no more hidden .terms-content sections, hide the "Load More" button
        if (jQuery(".terms-content:hidden").length === 0) {
            jQuery(".readMoreTerms").css('visibility', 'hidden');
        }
    }
});
});
jQuery(function () {
jQuery(".behind-page .col-md-5").slice(0, 6).show();
jQuery("body").on('click touchstart', '.load-more-behind', function (e) {
    e.preventDefault();
    jQuery(".behind-page .col-md-5:hidden").slice(0, 3).slideDown();
    if (jQuery(".behind-page .col-md-5:hidden").length == 0) {
        jQuery(".load-more-behind").css('visibility', 'hidden');
    }
    jQuery('html,body').animate({
        scrollTop: jQuery(this).offset().top
    }, 1000);
});      
});

//price range filter
const rangeInput = document.querySelectorAll(".range-input input"),
priceInput = document.querySelectorAll(".price-input input"),
range = document.querySelector(".slider .progress");
let priceGap = 1000;

priceInput.forEach((input) => {
input.addEventListener("input", (e) => {
let minPrice = parseInt(priceInput[0].value),
    maxPrice = parseInt(priceInput[1].value);

if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
    if (e.target.className === "input-min") {
        rangeInput[0].value = minPrice;
        range.style.left = (minPrice / rangeInput[0].max) * 100 + "%";
    } else {
        rangeInput[1].value = maxPrice;
        range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
    }
}
});
});

rangeInput.forEach((input) => {
input.addEventListener("input", (e) => {
let minVal = parseInt(rangeInput[0].value),
    maxVal = parseInt(rangeInput[1].value);

if (maxVal - minVal < priceGap) {
    if (e.target.className === "range-min") {
        rangeInput[0].value = maxVal - priceGap;
    } else {
        rangeInput[1].value = minVal + priceGap;
    }
} else {
    priceInput[0].value = minVal;
    priceInput[1].value = maxVal;
    range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
    range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
}
});
});

